/**
 * The selected state given to an `asChild` element on top of `aria-current`.
 * None on web: `aria-current` marks the current page there, and the element
 * may be a DOM link that knows no React Native props.
 */
export const asChildSelectedProps = (
  _selected: boolean,
  _ownState: object | undefined,
): Record<string, unknown> => ({});
